module.exports = __webpack_public_path__ + "fonts/CashSans-SemiboldItl.fa6e3da.woff2";